var map = {
	"./el.json": "eb91",
	"./en-GB.json": "5a38",
	"./en.json": "0e40",
	"./hi.json": "4624",
	"./in.json": "cc94",
	"./ja.json": "af4f",
	"./ko.json": "ce4ed",
	"./pt.json": "421c",
	"./te.json": "c710",
	"./th.json": "31ee",
	"./vi.json": "47f9",
	"./zh.json": "ec1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adb0";